// dropdown esc key
document.addEventListener('keyup', (event) => {
	if (event.key !== 'Escape') {
		return;
	}

	const menu = document.querySelector('.dropdown-menu.show');

	if (!menu) {
		return;
	}

	window.Liferay.DropdownProvider.hide({ menu });
});

function showAvatar() {
	if (!window.userInfo) {
		return;
	}

	const avatarSrc = `api/user-profiles/profile/${userInfo.id}/avatarFile`;

	const dropdownAvatar = document.getElementById('dropdown-avatar');
	if (dropdownAvatar) {
		dropdownAvatar.addEventListener('error', (event) => {
			event.target.remove();
			document.getElementById('dropdown-avatar-default')?.classList.toggle('d-none');
		});
		dropdownAvatar.src = avatarSrc;
	}

	const dropdownHeaderAvatar = document.getElementById('dropdown-header-avatar');
	if (dropdownHeaderAvatar) {
		dropdownHeaderAvatar.addEventListener('error', (event) => {
			event.target.remove();
			document.getElementById('dropdown-header-avatar-default')?.classList.toggle('d-none');
		});
		dropdownHeaderAvatar.src = avatarSrc;
	}
}

showAvatar();
